export const VALID_ROLES = ['radiologist', 'staff_radiologist', 'coordinator'];

export const PII_ROLE = 'pii';
